import { formatDate } from '../../../../van-shared/utils/utils'

export const getFormattedDates = date => {
  return {
    printLong: formatDate(date, 'printLong'),
    printShort: formatDate(date, 'printShort'),
    short: formatDate(date, 'shortWithDay')
  }
}
